<div class="mt-2">
    <div class="pb-2">
        <button pButton type="button" label="New User" (click)="openCreateUserModal()"></button>
    </div>
    <th-new-data-table [definition]="tableDefinition" [data]="users"></th-new-data-table>
</div>